<template>
  <div>
    <el-dialog
      title="查看可评审专业"
      :visible.sync="visible"
      width="50%"
      top="6vh"
      v-loading="loading"
      :close-on-click-modal="false"
    >
      <el-tree :data="speTree"></el-tree>
    </el-dialog>
  </div>
</template>

<script>
import { listByBoard } from "@/api/infos/spe.js";

export default {
  data() {
    return {
      visible: false,
      loading: false,
      boardId: 0,
      speTree: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  methods: {
    show(boardId) {
      this.visible = true;
      this.boardId = boardId;

      this.listByBoard();
    },
    listByBoard() {
      this.loading = true;
      listByBoard(this.boardId).then((res) => {
        this.speTree = res;
        this.loading = false;
      });
    },
  },
};
</script>

 <style lang="scss" scoped>
</style>